import { Component, Input } from '@angular/core';

@Component({
  selector: 'apc-help-icon',
  templateUrl: './help-icon.component.html',
  styleUrls: ['./help-icon.component.scss']
})
export class HelpIconComponent {
  @Input() public text: string = '';
  goToDoc() {
    window.open('https://docs.google.com/document/d/1XKhhdXJftiQtzmNoeRSJwRFhKQsvZxmSlSa4v6SQQQU', '_blank');
  }
}
